import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';



export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false,
}

export const accountCreationListAll = createAsyncThunk('/customeraccountcreate/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getCustomeraccountcreate(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const accountCreationSubListAll = createAsyncThunk('/customeraccountcreate/subList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getCustomeraccountcreate(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})


export const accountCreationSlice = createSlice({
    name: 'accountCreation',
    initialState,
    reducers: {

        accountCreationList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(accountCreationListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(accountCreationListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
            .addCase(accountCreationSubListAll.pending, (state) => {

                state.subloading = false
            })
            .addCase(accountCreationSubListAll.fulfilled, (state, action) => {
                state.subloading = true
                state.sublist = action.payload
            })
    },
})

export const {
    accountCreationList


} = accountCreationSlice.actions

export default accountCreationSlice.reducer